import { render, staticRenderFns } from "./friend.vue?vue&type=template&id=92faa7fa&scoped=true"
import script from "./friend.vue?vue&type=script&lang=js"
export * from "./friend.vue?vue&type=script&lang=js"
import style0 from "./friend.vue?vue&type=style&index=0&id=92faa7fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92faa7fa",
  null
  
)

export default component.exports